
















import { faClock, faStar, faUserPlus } from '@fortawesome/free-solid-svg-icons'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import { computed, defineComponent, toRefs } from '@nuxtjs/composition-api'
import { useDep } from '~/compositions/dependency-container'

export default defineComponent({
  props: {
    inIframe: {
      type: Boolean,
      required: false,
      default: false
    },
    text: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: 'star'
    },
    iconColorClass: {
      type: String,
      default: 'tw-text-promote-turbo'
    },
    withoutPromo: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const legacyUrlService = useDep(LegacyUrlService)

    const { withoutPromo, inIframe } = toRefs(props)

    const registerLink = computed(() =>
      legacyUrlService.getRegisterUrl(
        withoutPromo.value ? {} : { 'from-promo': 1 }
      )
    )

    const target = computed(() => {
      return inIframe.value ? '_parent' : null
    })

    const icons = {
      userPlus: faUserPlus,
      star: faStar,
      clock: faClock
    }

    return { registerLink, target, faUserPlus, faStar, faClock, icons }
  }
})
